<!-- Unauthenticated users -->
@if ((currentUser$ | async) === null) {
  <div class="nav-item">
    <a mat-button routerLink="/about" routerLinkActive="active">Why QualityBidders?</a>
  </div>
} @else {
  <!-- Vendor users -->
  @if (isVendor) {
    <div class="nav-item">
      <a mat-button routerLink="/vendor" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
    </div>
    <div class="nav-item">
      <a mat-button routerLink="/vendor/applications" routerLinkActive="active">Applications</a>
    </div>
  }

  <!-- Agency or Colbi users -->
  @if (isAgency) {
    <div class="nav-item">
      <a mat-button routerLink="/agency" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
    </div>
    <div class="nav-item">
      <a mat-button routerLink="/agency/applications" routerLinkActive="active">Applications</a>
    </div>
  }

  <!-- Permission-based navigation -->
  @if (hasPermission('report:view') | async) {
    <div class="nav-item">
      <a mat-button routerLink="/agency/reports" routerLinkActive="active">Reports & Email</a>
    </div>
  }

  @if ((hasPermission('agency:management') | async) || (hasPermission('resource_template:manage') | async)) {
    <div class="nav-item">
      <a mat-button routerLink="/agency/management" routerLinkActive="active">Management</a>
    </div>
  }

  @if (hasPermission('colbi_admin:view') | async) {
    <div class="nav-item">
      <a mat-button routerLink="/admin" routerLinkActive="active">Colbi Admin</a>
    </div>
  }
}

<div class="nav-item">
  <a mat-button routerLink="/help" routerLinkActive="active">Help</a>
</div>
